/**
 * Texts for User Training page - Danish
 */
export const userTrainingPageText = {
    title: 'Brugertræning - CamAPS FX',
    titleMeta: 'Omfattende træningsressourcer til CamAPS FX-brugere',
    descriptionMeta: 'Adgang til komplette træningsmaterialer, videovejledninger, brugervejledninger og webinarer for at få mest muligt ud af CamAPS FX.',
    keywords:
        'camaps fx brugertræning, camaps træning, diabetestræning, insulinpumpe træning, brugervejledning, videovejledninger',
    localeMeta: 'da_dk',

    mainHeader: 'Brugertræning',
    mainSubHeader: 'Fuldfør den væsentlige træning i appen, før du bruger CamAPS FX-appen.',

    gettingStartedHeader: 'Kom i gang',
    step1Title: '<strong>Trin 1:</strong><br/>Download appen',
    step2Title: '<strong>Trin 2:</strong><br/>Opret en konto',
    step3Title: '<strong>Trin 3:</strong><br/>Begynd den væsentlige træning i appen',
    step4Title: '<strong>Trin 4:</strong><br/>Par med din valgte pumpe og CGM (med godkendelse fra dit sundhedsteam) eller udforsk appen med <strong>virtuel tilstand</strong>',
    videoSrc: '/video/In-app training loop_1.mp4', // Path to video in public folder

    supportSectionTitle: 'Brug for hjælp til at installere appen?',
    supportSectionText: 'Besøg vores supportsektion for vejledning',
    supportButtonText: 'SUPPORT',
    findOutMoreButtonText: 'LÆS MERE',

    additionalResourcesTitle: 'Yderligere ressourcer',
    additionalResourcesSubtitle: 'Lær gennem trin-for-trin-billeder eller se ekspertledede sessioner om brug af appen.',
    
    animationsTitle: 'Animationer',
    animationsDescription: 'Dana insulinpumpen er kun kommercielt tilgængelig med CamAPS FX i Storbritannien på nuværende tidspunkt. Alle ressourcer relateret til Dana er derfor kun tilgængelige på engelsk.',
    animationsLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',
    
    webinarsTitle: 'Webinarer',
    webinarsDescription: 'Disse webinarer er velegnede til personer, der lever med type 1-diabetes, deres familie og omsorgspersoner samt lærere, uddannelsesstøttepersonale og sundhedspersonale.',
    webinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    factsheetsTitle: 'Faktaark',
    factsheetsDescription: 'Dana insulinpumpen er kun kommercielt tilgængelig med CamAPS FX i Storbritannien på nuværende tidspunkt. Alle ressourcer relateret til Dana er derfor kun tilgængelige på engelsk.',
    factsheetsLink: 'https://www.camdiabtraining.com',

    inAppTrainingHeader: 'Træning i appen',
    inAppTrainingText: 'Start med den grundlæggende træning, der er indbygget i CamAPS FX-appen. Denne interaktive træning guider dig gennem alle de vigtige funktioner, du skal kende.<br/><br/><strong>Adgang:</strong> Download CamAPS FX-appen og opret en konto for at begynde din træning i appen.',

    gettingStartedText: '<strong>Trin 1:</strong> Download CamAPS FX-appen fra din enheds app-butik<br/><strong>Trin 2:</strong> Opret din konto<br/><strong>Trin 3:</strong> Fuldfør træningsmodulerne i appen<br/><strong>Trin 4:</strong> Tilslut din insulinpumpe og CGM<br/><strong>Trin 5:</strong> Start din CamAPS FX-rejse',

    trainingResourcesHeader: 'Yderligere træningsressourcer',
    videoTutorialsText: 'Videovejledninger',
    videoTutorialsDesc: 'Se trin-for-trin-videovejledninger, der dækker opsætning, daglig brug og fejlfinding.',
    videoTutorialsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    userGuidesText: 'Brugervejledninger og dokumentation',
    userGuidesDesc: 'Download omfattende PDF-vejledninger og hurtige referencematerialer.',
    userGuidesLink: 'https://www.camdiabtraining.com',
    
    webinarsText: 'Live-webinarer',
    webinarsDesc: 'Deltag i ekspertledede træningssessioner og spørgsmål og svar-muligheder.',

    needHelpHeader: 'Brug for hjælp?',
    needHelpTextStart: 'Hvis du har brug for hjælp eller har spørgsmål, besøg vores',
    supportLinkText: 'Support',
    needHelpTextEnd: 'side for yderligere hjælp og kontaktinformation.'
};

